// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2znY3","content":"styles_content__376-J","selectAll":"styles_selectAll__2157l"};